import React from "react";

import { formatCurrency, formatPercent } from "@features/real-estate/components/format";
import type { RealEstateComputedScenario } from "@features/real-estate/types";

type ScenarioCompareTableProps = {
  scenarios: RealEstateComputedScenario[];
};

const METRICS: Array<{
  key: keyof RealEstateComputedScenario["metrics"];
  label: string;
  formatter: (value: number | null | undefined) => string;
}> = [
  { key: "grossScheduledRent", label: "Gross scheduled rent", formatter: formatCurrency },
  { key: "effectiveGrossIncome", label: "Effective gross income", formatter: formatCurrency },
  { key: "noi", label: "NOI", formatter: formatCurrency },
  { key: "monthlyDebtService", label: "Monthly debt service", formatter: formatCurrency },
  { key: "monthlyCashFlow", label: "Monthly cash flow", formatter: formatCurrency },
  { key: "capRate", label: "Cap rate", formatter: formatPercent },
  { key: "cashOnCashReturn", label: "Cash-on-cash", formatter: formatPercent },
  { key: "dscr", label: "DSCR", formatter: (value) => value === null || value === undefined ? "N/A" : value.toFixed(2) },
  { key: "breakevenOccupancy", label: "Breakeven occupancy", formatter: formatPercent },
  { key: "leveredIRR", label: "Levered IRR", formatter: formatPercent },
  { key: "equityMultiple", label: "Equity multiple", formatter: (value) => value === null || value === undefined ? "N/A" : `${value.toFixed(2)}x` },
  { key: "cashToClose", label: "Cash to close", formatter: formatCurrency },
];

export function RealEstateScenarioCompareTable({ scenarios }: ScenarioCompareTableProps): React.ReactElement {
  return (
    <div className="re-compare-wrap">
      <table className="re-compare-table">
        <thead>
          <tr>
            <th>Metric</th>
            {scenarios.map(({ scenario }) => (
              <th key={scenario.id}>{scenario.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {METRICS.map((metric) => (
            <tr key={metric.key}>
              <td>{metric.label}</td>
              {scenarios.map(({ scenario, metrics }) => (
                <td key={`${scenario.id}-${metric.key}`}>{metric.formatter(metrics[metric.key])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
